import BASIC from './basic';

const Darcula = {
  ...BASIC,
  background: '#282C34',
  color: '#FFF',
};

export default Darcula;
